<template>
  <container-component class="cc-consul">
    <div class="h1">
      Consul is an incubator of great ideas across art, culture, and commerce. Headquartered in Los Angeles and London, we concept, curate, and invest in extraordinary creative projects.
    </div>
    <div class="h1">
      We channel the collective intelligence and creativity of our partners — artists, designers, brands, entrepreneurs, and investors — to create meaningful work that moves culture and builds community. Consul acts as a translation engine across this ecosystem, forging connections between like-minded collaborators who champion creative integrity and economic sustainability. 
    </div>
    <div class="h1">
      We treat every project as one of one. Our capabilities extend across the entire value chain, from concept and design to funding and distribution. This integrated approach enables us to assemble bespoke teams uniquely equipped to realize the promise of each project.
    </div>
  </container-component>
</template>

<script>
import ContainerComponent from "@/components/ContainerComponent.vue";

  export default {
    name: 'Consul',
    components: {
      ContainerComponent,
    }
  }
</script>

<style lang="scss" scoped>
.cc-consul {
  font-family: 'Space Grotesk';
  font-size: 64px;
  font-weight: 400;
}
</style>